import React from "react";
import css from "./InterventionDetails.scss";
import PropTypes from "prop-types";
import Icon from "../SF/MaterialIcon";
import {getStaffMemberConnectionProfileUrl} from "../utils/successNetworkURL";
import moment from "moment";
import sanitizeHtml from "sanitize-html";
import ReadMoreLessText from "../common/ReadMoreLessText";

const InterventionDetails = (props) => {
    const linkedName = (person) => {
        // Identifying the system raised flags
        if (person.name.toLowerCase() === 'system') return person.name;
        if (person.id === props.studentId) return 'you';
        return <a href={getStaffMemberConnectionProfileUrl(person.id)}>{person.name}</a>
    }

    const dueDate = moment(props.dueDate);
    // All of this extra `moment`ing here is to take time of day out of the equation.
    const daysOverdue = moment(moment().format('YYYY-MM-DD')).diff(moment(dueDate.format('YYYY-MM-DD')), 'days');
    const overdueMessage = () => {
        if (daysOverdue > 1) return `(${daysOverdue} Days Overdue)`;
        if (daysOverdue === 1) return `(${daysOverdue} Day Overdue)`;
        if (daysOverdue === 0) return '(Due Today)';
        if (daysOverdue === -1) return '(Due Tomorrow)';
    };

    const notes = props.raiseNotes &&
        sanitizeHtml(props.raiseNotes, {allowedTags: ['a', 'b', 'strong', 'i', 'em', 'br']})
            .replace(/\r?\n|\r/g, ' ')
            .trim();

    return (
        <div className={css['details']}>
            <div className={css['main-content']}>
                {props.assignee && <div className={css['intervention-details']} role={"text"} data-testid="notification-assignee">
                    <Icon icon='person' aria-hidden="true"/> <span>Assigned to {linkedName(props.assignee)}</span>
                </div>}
                <div className={css['intervention-details']} role={"text"} data-testid="notification-creator">
                    <Icon icon='person' aria-hidden="true"/>
                    <span>Created by {linkedName(props.raiser)} on {moment(props.raisedDate).format('MM-DD-YYYY')}</span>
                </div>
                {props.dueDate && <div className={css['intervention-details']} role={"text"} data-testid="notification-due-date">
                    <Icon icon='event' aria-hidden="true"/>
                    <span>Due {dueDate.format('MM-DD-YYYY')} <span className={css.red}>{overdueMessage()}</span></span>
                </div>}
                {props.plan && <div className={css['intervention-details']} role={"text"} data-testid="notification-plan">
                    <Icon icon='check_circle' aria-hidden="true"/> <span>{props.plan.name} {props.plan.openItemCount > 1 && `(1 of ${props.plan.openItemCount} active items)`}</span>
                </div>}
                {props.section && <div className={css['section']} role={"text"} data-testid="notification-section">
                    <img className={css['book-icon']} src="../images/starfish/icons/starfish_book.png" aria-hidden="true"/>
                    <span>{props.section.name} ({props.section.cmsCourseId})</span>
                </div>}
                {notes && <div className={css['raise-notes']} data-testid="notification-raise-notes">
                    <Icon icon="info" aria-hidden="true"/>
                    <ReadMoreLessText text={notes} allowHtml />
                </div>}
                {(props.type === 'TO_DO' && props.closureReviewRequired && props.requestedResolutionDate) &&
                    <div className={css['intervention-details']} role={"text"}>
                        <span>You took action on this item. It was sent for review on {moment(props.requestedResolutionDate).format('MM-DD-YYYY')}.</span>
                    </div>}
            </div>
            {props.footer}
        </div>);
}

InterventionDetails.propTypes = {
    id: PropTypes.number,
    assignee: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    }),
    dueDate: PropTypes.string,
    footer: PropTypes.element,
    name: PropTypes.string.isRequired,
    plan: PropTypes.object,
    raisedDate: PropTypes.string.isRequired,
    raiseNotes: PropTypes.string,
    raiser: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
    section: PropTypes.shape({
        cmsCourseId: PropTypes.string,
        name: PropTypes.string,
    }),
    studentId: PropTypes.number,
    type: PropTypes.string.isRequired,
    closureReviewRequired: PropTypes.bool.isRequired,
    requestedResolutionDate: PropTypes.string
}

export default InterventionDetails;
